import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { LoginInfo, RefreshTokenRequest } from "@/services/login-service/entities/LoginEntity.ts";
import { LoginManager, LoginManagerImpl } from "@/services/login-service/LoginService.ts";

const loginManager: LoginManager = new LoginManagerImpl();

if (!window.axiosInstance) {
  window.axiosInstance = axios.create({
    headers: {
      ClientId: window.__clientId__,
      ContentType: "application/json",
    },
    // transformRequest: [
    //   dateTransformer,
    //   ...(axios.defaults.transformRequest as AxiosTransformer[]),
    // ],
  });
  window.axiosInstance.interceptors.request.use(
    async (config: AxiosRequestConfig | any) => {
      config.headers["ClientId"] = window.__clientId__;
      const loginInfo: LoginInfo = new LoginInfo(
        JSON.parse(localStorage.getItem("LOGIN_INFO") || "{}")
      );
      if (loginInfo.accessToken && config.headers) {
        config.headers["Authorization"] = `Bearer ${loginInfo.accessToken}`;
      }
      return config;
    },
    (error: any) => {
      return Promise.reject(error);
    }
  );
  let refreshTokenPromise: any;
  window.axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
      return response;
    },
    async function (error: AxiosError | any) {
      if (error.config && error.response && error.response?.status === 401) {
        if (!refreshTokenPromise) {
          const loginInfo: LoginInfo = new LoginInfo(
            JSON.parse(localStorage.getItem("LOGIN_INFO") || "{}")
          );
          refreshTokenPromise = loginManager
            .refreshToken(
              new RefreshTokenRequest(loginInfo.refreshToken),
              loginInfo
            )
            .then((response: LoginInfo) => {
              if (!response.accessToken) {
                loginManager.logout();
                return "";
              } else {
                refreshTokenPromise = null;
                return response.accessToken;
              }
            });
        }
        return refreshTokenPromise.then((token: string) => {
          if (token) {
            error.config.headers["Authorization"] = `Bearer ${token}`;
            return window.axiosInstance.request(error.config);
          } else {
            loginManager.logout();
          }
        });
      }
      return Promise.reject(error);
    }
  );
}

export default window.axiosInstance;